module.exports = __webpack_public_path__ + "static/media/Icon4.f16ed7fd.png";